import { render, staticRenderFns } from "./HostRound.vue?vue&type=template&id=4eb9a2f4&scoped=true&"
import script from "./HostRound.vue?vue&type=script&lang=ts&"
export * from "./HostRound.vue?vue&type=script&lang=ts&"
import style0 from "./HostRound.vue?vue&type=style&index=0&id=4eb9a2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb9a2f4",
  null
  
)

export default component.exports